module.exports ={
    shops: {
        all: '全店',
        statusOpt:[
            {
                label: '全店',
                value: true
            },{
                label: '閉店店舗',
                value: false
            }
        ],
        add:'追加',
        addTip: {
            success: 'ストアが正常に追加されました',
            exist: 'ストアはすでに存在します',
            fail:'ストアを追加できませんでした',
            permission: 'ストアを追加する権限がありません'
        },
        find:'店舗を検索',
        addTitle: 'ストアを追加',
        storeId: '店舗番号',
        no:'番号: ',
        storeIdMsg: '店舗番号を入力してください',
        storeIdMsg1: '番号字または文字を入力してください',
        storeIdExist: 'ストアはすでに存在します',
        storeIdFail: '失敗しました。再入力してください',
        storeName: '店舗名',
        storeNameMsg: '店舗名を入力してください',
        storeAddress: '店舗住所',
        address: '住所: ',
        storeAddressMsg: '店舗の住所を入力してください',
        serviceAddress: 'サーバーアドレス',
        serviceAddressMsg: '有効なサーバーアドレスを入力してください',
        storeImg: '店舗カバー',
        storeImgMsg: '店舗カバーをアップロードしてください',
        cancel: 'キャンセル',
        save: '保存',
        uploadMsg: '新しいカバーをアップロード',
        uploadType:'アップロードされた画像はJPGまたはPNG形式でのみ使用できます',
        uploadSizeLt: '画像サイズは370 * 370以内である必要があります',
        uploadFailed:'画像のアップロードに失敗しました',
        sure: '確定',
        status: {
            on: '開いた',
            off: '休業'
        },
        noData: 'データなし',
        submiting: '保存中...'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/shops.js